import React, {Fragment} from 'react';
import {Container} from "@mui/material";
import TripInfo from "./SelectRoom/TripInfo";
import TripHead from "./SelectRoom/TripHead";
import {makeStyles} from "@mui/styles";
import BookingStepper from "./BookingStepper";
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    mainContent:{
        paddingTop:40
    }
}));

function BookingContainer({allStepsCompleted,activeStep,steps,setStep,isStepComplete,trip,getContent,setStepBack}) {
    const classes = useStyles();
    const getAllSteps =() =>{
        return allStepsCompleted();
    }
    const prefix = window['siteUrl'];
    const confirmationBanner = prefix+'/images/confirmation/banner.jpg';
    return (
        <Fragment>
            {activeStep===0 && <TripHead trip={trip} />}
            <Container maxWidth="lg" className={classes.mainContent}>
                <BookingStepper activeStep={activeStep} steps={steps} setStep={setStep}
                                isStepComplete={isStepComplete} setStepBack={setStepBack}/>
                {activeStep===0 && <TripInfo trip={trip} />}
                {activeStep===6 && <div style={{backgroundImage:`url("${confirmationBanner}")`,backgroundPositionY:'center'}} className={'confirmationBanner'} />}
                <div style={{marginTop:50}}>
                    { getAllSteps() ? (
                        <div>
                        {/*Print confirmation*/}
                        </div>
                    ) : (
                        <div>
                            {getContent(activeStep)}
                        </div>
                    )}
                </div>
            </Container>
        </Fragment>
    );
}

export default BookingContainer;